import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/services/modal.service';
import { getCapturedImage } from 'src/app/store/actions/shared.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.scss']
})
export class CameraComponent implements OnInit {

  @ViewChild('video') video!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas') canvas!: ElementRef<HTMLCanvasElement>;

  cameraStream: MediaStream | null = null; // store the stream

  capturedImage: any;

  imgBase64: any;

  constructor(
    private cdr: ChangeDetectorRef,
    private modalService: ModalService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    this.startCamera(false);
  }

  startCamera(retake) {
    if(retake){
      this.capturedImage = null;
      this.cdr.detectChanges();
    }
    if(!this.cameraStream){
      navigator.mediaDevices.getUserMedia({ video: true })
        .then(stream => {
          this.cameraStream = stream;
          this.cdr.detectChanges();
          this.video.nativeElement.srcObject = stream;
          this.video.nativeElement.play();
        })
        .catch(err => console.error('Error accessing camera: ', err));
    }
  }

  stopCamera() {
    if (this.cameraStream) {
      this.cameraStream.getTracks().forEach(track => track.stop());
      this.cameraStream = null;
    }

    // Optional: clear the video element
    if (this.video?.nativeElement) {
      this.video.nativeElement.srcObject = null;
    }
  }
  

  capture() {
    const context = this.canvas.nativeElement.getContext('2d');
    if (context) {
      context.drawImage(this.video.nativeElement, 0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
      this.capturedImage = this.canvas.nativeElement.toDataURL('image/png');
      this.imgBase64 = this.capturedImage;
      if(this.capturedImage){
        const filename = this.generateRandomString(10);
        const convertToFile = this.base64ToFile(this.capturedImage, filename);
        this.capturedImage = convertToFile;
      }
      this.stopCamera();
    }
  }

  base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : '';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    // Extract extension from MIME type
    const extension = mime ? mime.split('/')[1] : '';
    const fullFilename = extension ? `${filename}.${extension}` : filename;

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fullFilename, { type: mime });
  }

  generateRandomString(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  async dismiss(){
    await this.stopCamera();
    this.modalService.hideCameraModal();
  }

  async submit(){
    const payload = {
      file: this.capturedImage,
      base64: this.imgBase64
    }
    await this.store.dispatch(getCapturedImage({data: payload, captureType: 'camera'}));
    this.dismiss();
  }
}
